/**
 * Indian mobile number validation + normalization.
 *
 * A valid Indian mobile number must:
 *   - Contain exactly 10 digits after stripping spaces, dashes, leading "+",
 *     leading "91" country code, or a leading "0" trunk prefix.
 *   - The first digit of the 10-digit core must be 6, 7, 8, or 9.
 *
 * Accepted input formats (all return the same normalized value):
 *   "9876543210"         → "+919876543210"
 *   "+91 9876543210"     → "+919876543210"
 *   "+919876543210"      → "+919876543210"
 *   "091 9876543210"     → "+919876543210"
 *   "98765 43210"        → "+919876543210"
 *   "9876-543-210"       → "+919876543210"
 */
export const validateIndianMobile = (raw) => {
  if (raw === null || raw === undefined) {
    return { valid: false, normalized: null, reason: "empty" };
  }

  const trimmed = String(raw).trim();
  if (trimmed.length === 0) {
    return { valid: false, normalized: null, reason: "empty" };
  }

  // Strip whitespace, dashes, parentheses, and a leading "+"
  let digits = trimmed.replace(/[\s\-()]/g, "");
  if (digits.startsWith("+")) {
    digits = digits.slice(1);
  }

  // Must be all digits at this point
  if (!/^\d+$/.test(digits)) {
    return { valid: false, normalized: null, reason: "invalid" };
  }

  // Strip country code "91" if present and total length is 12
  if (digits.length === 12 && digits.startsWith("91")) {
    digits = digits.slice(2);
  }
  // Strip a single leading "0" trunk prefix if length is 11
  else if (digits.length === 11 && digits.startsWith("0")) {
    digits = digits.slice(1);
  }

  // Now must be exactly 10 digits, first digit 6/7/8/9
  if (!/^[6-9]\d{9}$/.test(digits)) {
    return { valid: false, normalized: null, reason: "invalid" };
  }

  return { valid: true, normalized: `+91${digits}`, reason: null };
};

export const PHONE_ERROR_MESSAGES = {
  empty: "Please enter your WhatsApp number.",
  invalid: "Please enter a valid 10-digit Indian mobile number.",
};
